webpackJsonp([170844033123148],{

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/product.fb525a9e.jpg";

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(8);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(9);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _product = __webpack_require__(361);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Product = (0, _reactI18next.translate)('product')(function (_ref) {
	  var t = _ref.t;
	  return _react2.default.createElement(
	    'div',
	    { id: 'product' },
	    _react2.default.createElement(_Header2.default, { current: 'product' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col4 col-pad1' },
	        _react2.default.createElement(
	          'section',
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Historie'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Decentralized social discussion platform'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'product-image' },
	            _react2.default.createElement('img', { src: _product2.default })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'product-caption' },
	            t('d1')
	          )
	        )
	      )
	    )
	  );
	});
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      meta: [{ name: 'description', content: 'Babels Product' }, { property: 'og:title', content: 'Babels Product' }, { property: 'og:url', content: 'https://babels.co/product' }, { property: 'og:image', content: 'https://dummyimage.com/600x400/000/fff' }, { property: 'og:image:width', content: '600' }, { property: 'og:image:height', content: '400' }, { property: 'og:description', content: 'Babels Product' }, { name: 'twitter:card', content: 'summary_large_image' }, { name: 'twitter:site', content: '@null' }, { name: 'twitter:creator', content: '@null' }]
	    }),
	    _react2.default.createElement(Product, null)
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-product-js-99763a42c8ce412e3a8f.js